export { mcpPages } from './mcpPages';
